import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'

export class UnassignMetricFromOrganizationUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    organizationId: string,
    metricId: string,
    applicationId: string,
    riskType?: string | null,
  ): Promise<void> {
    return this.repository.unassignMetricFromOrganization(
      organizationId,
      metricId,
      applicationId,
      riskType,
    )
  }
}
